<template>
  <el-input
      ref="scanningInput"
      v-model="inputValue"
      :placeholder="placeholder"
      @keyup.enter.native="handleEnter"
  ></el-input>
</template>

<script>
import {keyboardKeys} from "@/utils/windowsUtils";
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    //是否已清理input 的内容
    hasCleared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHasCleared: this.hasCleared,
      inputValue: this.value,
      lastInputTime: Date.now(),
      lastInputValue: '',//上次输入框的值
      clearLastInputValueFlag: false,//清理上次input框输入的内容的flag
      scanTimeThreshold: 30,//扫码时间
    };
  },
  watch: {
    inputValue(newValue) {
      if (newValue || newValue === '') {
        this.$emit('input', newValue);
      }
    },
    value(newValue) {
      this.inputValue = newValue;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.scanningInput.focus()
      document.body.addEventListener('keydown', this.listenerKeyDown)
      document.body.addEventListener('keyup', this.listenerUp)
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('keydown', this.listenerKeyDown)
    document.body.removeEventListener('keyup', this.listenerUp)
  },
  methods: {
    listenerUp(event) {
      if (event.keyCode !== '13') {
        if (this.$refs.scanningInput && event.target === this.$refs.scanningInput.$el.querySelector('input')) {
          this.lastInputValue = event.target.value.substring(event.target.value.length - 1)
        }
      }
    },
    listenerKeyDown(event) {
      if (event.keyCode !== '13') {
        const currentTime = Date.now();
        if (event.target === document.body) {
          this.lastInputTime = Date.now();
          if (currentTime - this.lastInputTime < this.scanTimeThreshold) {
            // 当与上次时间小于扫码时间时
            if (!this.isHasCleared) {
              // 第一次未清理时，则清理对应的input 的内容
              if (this.$refs.scanningInput) {
                this.$refs.scanningInput.focus()
              }
              this.inputValue = ''
              this.isHasCleared = true
            } else {
              this.isHasCleared = false
            }
          }
        } else if (this.$refs.scanningInput && event.target === this.$refs.scanningInput.$el.querySelector('input')) {
          // 在input 框内输入
          if (currentTime - this.lastInputTime < this.scanTimeThreshold) {
            if (!this.isHasCleared) {
              if (this.inputValue) {
                this.inputValue = this.clearLastInputValueFlag ? '' : this.lastInputValue
              }
              this.isHasCleared = true
            }
          } else {
            this.clearLastInputValueFlag = keyboardKeys.includes(event.key);
            this.isHasCleared = false
          }
        }
        this.lastInputTime = currentTime;
      }
    },
    // 当按下 Enter 键时触发事件
    handleEnter() {
      this.$emit('enter');
    }
  },

};
</script>


